import { calculateMultiselects } from "./calculate-multiselects";
import { getCurrentAttributesSelection } from "./get-current-attributes-selection";
import { PDPInternalState, PDPSwarovskiProductFrontend, PDPSwarovskiProductVariantFrontend } from "./types";

export function getPDPState(
  selectedProduct: PDPSwarovskiProductFrontend,
  selectedVariantMaybe: PDPSwarovskiProductVariantFrontend | undefined,
): PDPInternalState {
  const multiselectsForProduct = calculateMultiselects(selectedProduct);
  const { attributesSelection, selectedVariant, tag } = getCurrentAttributesSelection(
    selectedProduct,
    selectedVariantMaybe,
    multiselectsForProduct,
  );

  return {
    selectedProduct: selectedProduct,
    selectedVariant: selectedVariant,
    multiselectsForProduct: multiselectsForProduct,
    attributesSelection: attributesSelection,
    variantSelectionMethod: tag,
  };
}
